




import Vue from "vue";

export default Vue.extend({
  name: "App",

  methods: {
    handler(e: BeforeUnloadEvent) {
      if (this.$route.meta.step !== "thanks") {
        e.preventDefault();
        e.returnValue = "";
      }
    }
  },

  created() {
    window.addEventListener("beforeunload", this.handler);
  },
  destroyed() {
    window.removeEventListener("beforeunload", this.handler);
  }
});
